import { r as e } from "./index-D7cgykJH.js";
const s = e("Browser", {
  web: () => import("./web-Bh98FeXM.js").then((r) => new r.BrowserWeb())
});
export {
  s as B
};
//# sourceMappingURL=index-BZpqZYNM.js.map
